import React from "react";
import LegalDocumentPage from "../components/legal/LegalDocumentPage";
import publicLegalDocuments from "../legal/publicLegalDocuments.json";

export default function TermsPage() {
  return <LegalDocumentPage document={publicLegalDocuments.terms} />;
}
